import { HomeProject } from '@models/swagger';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './project.actions';
import cloneDeep from 'clone-deep';

export interface State {
  project: HomeProject;
  nonModifiedProject: HomeProject;
  writtenPartnershipCardNumber: string | null;
}

export const featureKey = 'flowDataProject';

export const initialState: State = {
  project: {},
  nonModifiedProject: {},
  writtenPartnershipCardNumber: null,
};

export function projectReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.ProjectClearData, state => ({
      ...state,
      project: {},
      nonModifiedProject: {},
      writtenPartnershipCardNumber: null,
    })),
    on(Actions.ProjectUpdateProject, (state, { data }) => ({ ...state, project: cloneDeep(data) })),
    on(Actions.ProjectEmptyProject, state => ({ ...state, project: {} })),
    on(Actions.ProjectUpdateNonModified, (state, { data }) => ({ ...state, nonModifiedProject: cloneDeep(data) })),
    on(Actions.ProjectEmptyNonModified, state => ({ ...state, nonModifiedProject: {} })),
    on(Actions.WrittenPartnershipCardNumber, (state, { data }) => ({ ...state, writtenPartnershipCardNumber: data }))
  )(state, action);
}
